

import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import './index.scss';
import ComHeader from '@/components/comHeader';
import ComVoid from '@/components/comVoid';
import ComTag from '@/components/comTag';
import Item from './item';
import { useHistory } from "react-router-dom";
import { listReq, taskReq, listBaseReq, recIsBai, alertShow } from '@/store/actions'
import { setTopBar, setShare } from '@/utils/jrSdk'
import { GetRequest, listenPageStatus } from '@/utils';
import InfiniteScroll from 'react-infinite-scroller';
function List() {
    const { config, list, pageNo, end } = useSelector(state => state.list);
    const { isBai ,btUrl }  = useSelector(state => state.base);
    const [channelCode, setChannelCode] = useState(GetRequest('channelCode'));
    const dispatch = useDispatch();
    const history = useHistory();
    function handleBtn(info) {
        const btText = {
            title: '需要开通白条才能参加活动哦~',
            btnText: '我知道了',
            action: () => window.locationTo({ url: btUrl })
        }
        switch(info.realStatus) {
            case 'ac0': {
                    if(isBai) dispatch(taskReq({ channelCode: channelCode, taskCode: info.taskCode }));
                    else dispatch(alertShow(btText))
                };break;
            case 'ac1':
            case 'ac2':
            case 'fr2':
            case 'rw2':
            case 'rw4':
                window.locationTo({
                    url: '/home',
                    params: {
                        channelCode,
                        taskCode: info.taskCode
                    }
                });
                break
        }
    }
    useEffect(() => {
        dispatch(listBaseReq({ pageId: '3684' }));
        dispatch(listReq({ channelCode: channelCode, sortType: 1, pageNo }));
        dispatch(recIsBai());
    }, [])
    useEffect(() => {      
        setTopBar({title: config.headTitle || '打白条笔笔攒' , bg: '#004CF1'})
        setShare(config.share);
    }, [config])
    function toPast(parentTaskCode) {
        window.locationTo({
            url: '/past',
            params: {
                channelCode,
                parentTaskCode
            }
        })
    }
    function getMore() {
        if(end) return ;
        dispatch(listReq({ channelCode: channelCode, sortType: 1, pageNo }));
    }
    return (
        <div className='list'>
            <ComHeader info={config} ruleCls='rwlist|rule'/>
            {
                list && 
                list.length?
                <InfiniteScroll
                    pageStart={pageNo}
                    loadMore={getMore}
                    hasMore={!end}
                >
                    <div className='list-panel'>
                    {
                        list.map((it, idx) => <Item info={it} key={idx} handleBtn = {handleBtn} toPast={toPast}/>)
                    }
                    </div>
                </InfiniteScroll>: 
                list &&
                list.length === 0 &&
                end ?<ListVoid voidBtnUrl = {config.mark3} />:null
            }
            
                {
                    end?<ComTag title='京东金融'></ComTag>:null
                }
                
        </div>
    )
}

function ListVoid({
    voidBtnUrl
}) {
    function toJump() {
        window.locationTo({
            url: voidBtnUrl
        })
    }
    return (
        <div className='list-void'>
                <div className='list-void-box'>
                    <ComVoid text='活动正在准备中哦~'></ComVoid>
                </div>
                {
                    voidBtnUrl?<div 
                    onClick={toJump}
                    className='list-void-btn'                     
                    >
                    去看看其他活动
                    </div>:null
                
                }
                
            </div>
    )
}
export default List;